import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfig } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { EVENT_TYPE_FILTER_LIMIT } from '../../filterDefaultLimits';

const EVENT_TYPE_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.activity_type`],
    limit: EVENT_TYPE_FILTER_LIMIT,
    filters: [
      { member: `${sourceCube}.is_invitation`, operator: 'equals', values: ['1'] },
      { member: `${sourceCube}.hcp_bk`, operator: 'set' },
    ],
    timeDimensions: [timeDimensions],
  };
  return query;
};

const eventTypeFilter: FilterConfig = {
  searchable: true,
  label: 'global.filters.formControls.eventTypeLabel',
  placeholder: 'global.filters.formControls.eventTypePlaceholder',
  type: 'multiselect',
  clearable: true,
  getOptionsQuery: EVENT_TYPE_OPTIONS,
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.activity_type`),
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION}.activity_type`,
      operator: 'equals',
      values: [...v],
    };
  },
  defaultValue: [],
};

export default eventTypeFilter;
